/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-26 17:20:26
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-27 11:50:44
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/Export/index.tsx
 */
import React from 'react';
import { ModalFooter, Radio } from 'src/components/Antd';
import css from './css.module.less';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import { useI18n } from 'src/hooks/useRouterChange';
import {
  getI18nFromGeneral,
  i18nGet,
  replaceI18nVariables,
} from 'src/tools/tools';

export enum EnumScope {
  Current = 'Current',
  All = 'All',
  Selected = 'Selected',
}
enum EnumFormat {
  CSV = 'CSV',
  Excel = 'Excel',
}
const Export = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    currentUuid = [],
    selectedUuid = [],
    onExport,
    onCancel,
    scopeList = [],
    defaultScope,
  } = props;
  const [scope, setScope] = React.useState(defaultScope || EnumScope.All);
  const [format, setFormat] = React.useState(EnumFormat.Excel);
  const handleOnExport = () => {
    if (onExport) {
      if (scope === EnumScope.Selected) {
        onExport({
          uuid: selectedUuid,
          format,
          scope,
        });
      }
      if (scope === EnumScope.Current) {
        onExport({
          uuid: currentUuid,
          format,
          scope,
        });
      }
      if (scope === EnumScope.All) {
        onExport({
          uuid: [],
          format,
          scope,
        });
      }
    }
  };
  const scopeDic = {
    [EnumScope.Current]: {
      label: 'Current Page',
      value: EnumScope.Current,
      // className: css.radio,
    },
    [EnumScope.All]: {
      label: 'All Products',
      value: EnumScope.All,
      //className: css.radio,
    },
    [EnumScope.Selected]: {
      label: `Selected Products: ${selectedUuid.length}`,
      value: EnumScope.Selected,
      disable: !selectedUuid.length,
    },
  };
  const generateScope = () => {
    return scopeList.map((i, index, self) => {
      const comp = scopeDic[i];
      if (index !== self.length - 1 && comp) {
        comp.className = css.radio;
      }
      return comp;
    });
  };
  return (
    <React.Fragment>
      <div className={css.container}>
        <ItemWrapper title={getI18nFromGeneral('general.export1.export')}>
          <Radio
            className={css.radioGroup}
            radioList={generateScope()}
            value={scope}
            onChange={(e) => setScope(e.target.value)}
          />
        </ItemWrapper>
        <ItemWrapper title={getI18nFromGeneral('general.export1.exportas')}>
          <Radio
            className={css.radioGroup}
            radioList={[
              {
                label: getI18nFromGeneral('general.export1.excel(.xlsx)'),
                value: EnumFormat.Excel,
                className: css.radio,
              },
              {
                label: replaceI18nVariables(
                  getI18nFromGeneral('general.export1.plainCSVfile(utf-8)'),
                  8,
                ),
                value: EnumFormat.CSV,
              },
            ]}
            value={format}
            onChange={(e) => setFormat(e.target.value)}
          />
        </ItemWrapper>
      </div>
      <ModalFooter
        onCancel={onCancel}
        onOk={handleOnExport}
        okText={getI18n('general.export1.export')}
        cancelText={getI18n('general.cancel')}
      />
    </React.Fragment>
  );
};
export default Export;
